
// Cookie and Popup Element
let cookieBannerEl = null;
let popupEl = null;

// INERT HELPERS

function applyInert(el) {
    if (el) el.inert = true;
}

function removeInert(el) {
    if (el) el.inert = false;
}


// VISIBILITY CHECK
function isPopupVisible() {
    let el = document.querySelector('[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]')
    if (!el) return false;

    // if (!document.contains(el)) return false;

    try {
        const style = getComputedStyle(el);

        return (
            style.display !== 'none'
        );
    } catch (e) {
        return false;
    }
}

function isCookieBannerVisible() {
    const host = document.querySelector('csm-cookie-consent');
    if (!host || !host.shadowRoot) return false;

    const wrapper = host.shadowRoot.querySelector('#csm-wrapper');
    return !!wrapper?.querySelector("[role='dialog'].cc-banner");
}

// Get Current Active Layer
function getActiveLayer() {
    try {
        if (isCookieBannerVisible()) return 'COOKIE';
        if (isPopupVisible()) return 'POPUP';
        return 'SITE';
    } catch (e) {
        return 'SITE';
    }
}

function isValidElement(el) {
    return el && document.contains(el);
}

// Update Interaction Based on Active Layer
function updateInteractionState() {

    if (!isValidElement(popupEl)) popupEl = null;
    if (!isValidElement(cookieBannerEl)) cookieBannerEl = null;
    const active = getActiveLayer();
    let siteContainer = document.getElementById("site-container")
    if (active === 'POPUP') {
        removeInert(popupEl);
        applyInert(cookieBannerEl);
        applyInert(siteContainer);
    }

    else if (active === 'COOKIE') {
        removeInert(cookieBannerEl);
        applyInert(popupEl);
        applyInert(siteContainer);
    }

    else {
        removeInert(cookieBannerEl);
        removeInert(popupEl);
        removeInert(siteContainer);
    }
}

// Cookie Handling 
function handleCookieHost(hostEl) {

    const shadow = hostEl.shadowRoot;
    // Remove Popover Attribure
    // hostEl?.removeAttribute("popover")
    if (!shadow) return;

    // wait for wrapper inside shadow
    const observer = new MutationObserver(() => {
        document.querySelector("csm-cookie-consent")?.removeAttribute("popover")
        const wrapper = shadow.querySelector('#csm-wrapper');
        // if (wrapper) {
        const banner = wrapper?.querySelector("[role='dialog'].cc-banner");

        // if (banner) {
        cookieBannerEl = banner;
        updateInteractionState();
        // }
        // }
    });
    updateInteractionState();
    observer.observe(shadow, { childList: true, subtree: true });
}

// observe Element
function observeForElement({
    targetSelector,
    parentEl = document.body,
    subtree = false,
    timeout = 10000,
    onFound = () => { },
    onError = () => { }
} = {}) {
    let observer = null;
    let timer = null;

    function cleanup() {
        if (observer) observer.disconnect();
        if (timer) clearTimeout(timer);
    }

    try {
        const existing = parentEl.querySelector(targetSelector);
        if (existing) {
            onFound(existing);
            return cleanup;
        }


        observer = new MutationObserver((mutations) => {
            try {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (node.nodeType !== 1) continue;

                        if (node.matches?.(targetSelector)) {
                            cleanup();
                            onFound(node);
                            return;
                        }

                        if (subtree && node.querySelector) {
                            const el = node.querySelector(targetSelector);
                            if (el) {
                                onFound(el);
                                cleanup();
                                return;
                            }
                        }
                    }
                }
            } catch (err) {
                cleanup();
                onError(err);
            }
        });

        observer.observe(parentEl, { childList: true, subtree });


        timer = setTimeout(() => {
            cleanup();
            onError(new Error(`Timeout: ${targetSelector} not found`));
        }, timeout);

    } catch (err) {
        cleanup();
        onError(err);
    }

    return cleanup;
}

// DETECT COOKIE HOST
observeForElement({
    targetSelector: 'csm-cookie-consent',
    parentEl: document.body,
    subtree: false,
    timeout: 30000,
    onFound: (el) => {

        let cookie = document.querySelector("csm-cookie-consent")
        if (cookie) {
            cookie.removeAttribute("popover")
            cookie.style.setProperty("z-index", "2147483647", "important");
        }
        handleCookieHost(el);

    },
    onError: (err) => {
        console.log("error on cookie consent", err)
    }
});

// DETECT POPUP
observeForElement({
    targetSelector: '[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]',
    parentEl: document.body,
    subtree: true,
    timeout: 30000,
    onFound: (el) => {
        popupEl = el;

        // // observe visibility changes
        const observer = new MutationObserver(() => {
            updateInteractionState();
        });

        observer.observe(el, {
            attributes: true,
            attributeFilter: ['style', 'class', 'aria-hidden'],
            subtree: true
        });

        updateInteractionState();
    },
    onError: (err) => {
        console.log("error on popup", err)
    }
});

updateInteractionState();


// FallBack Case 
setTimeout(() => {
    let popupForm = document.querySelector('[role="dialog"][aria-modal="true"][aria-label="POPUP Form"].needsclick[class*="kl-private-reset-css-"]')
    popupForm?.addEventListener("click", () => {
        let siteContainer = document.getElementById("site-container")
        if (siteContainer) {
            removeInert(siteContainer)
        }
    }, { once: true })
}, 18000)

// Search  Dropdown Focus Trap 

    setTimeout(() => {
        // Add / Remove Listeners
        const container = document.getElementById('boost-sd__search-widget-init-wrapper');
        let isListenerAdded = false;
        // Event Listener For Focus On Item List
        function handleDocKeydown(e) {


            if (e.key !== 'Tab') return;
            const focusable = getFocusable();


            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const isInside = document.getElementById('boost-sd__search-widget-init-wrapper').contains(document.activeElement);
            if (!isInside && document.activeElement !== input) return;

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                   if (document.activeElement === last) {
        if (e.target.closest('.boost-sd__view-all')) {
            e.preventDefault();
            const searchInput = document.querySelector('#boost-sd__search-widget-init-input-0');
            if (searchInput) {
                searchInput.focus();
            }
            return;
        }
        e.preventDefault();
        first.focus();
    }
            }
        }



        function getFocusable() {
            return document.getElementById('boost-sd__search-widget-init-wrapper').querySelectorAll(
                'a.boost-sd__suggestion-queries-item-link, a.boost-sd__view-all-link'
            );
        }


        function addDocListener() {

            if (!isListenerAdded) {

                document.addEventListener('keydown', handleDocKeydown);
                isListenerAdded = true;
            }
        }

        function removeDocListener() {

            if (isListenerAdded) {
                document.removeEventListener('keydown', handleDocKeydown);
                isListenerAdded = false;
            }
        }



        const input = document.querySelector('#nogin-search-app > .search-box > form  > input');
        input?.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                const focusable = getFocusable();
                if (focusable.length) {
                    e.preventDefault();
                    setTimeout(() => {
                        focusable[0].focus();
                    }, 0);
                }
            }
        });



        // Observer for Input Search Dropdown
        // const target = document.getElementById("boost-sd__search-widget-init-wrapper");
        const target = document.querySelectorAll(".search-menu-item-dropdown")[0]

        if (!target) {
            console.log("Element not found");
        } else {
            const checkState = () => {
                const display = window.getComputedStyle(target).display;
                if (display == 'none') {
                    removeDocListener();
                } else {
                    addDocListener();
                }
            };

            // initial check
            checkState();

            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "attributes" && mutation.attributeName === "style") {
                        checkState();
                    }
                }
            });

            observer.observe(target, {
                attributes: true,
                attributeFilter: ["style"]
            });
        }
    }, 8000)
